export default __webpack_public_path__ + "static/media/executiveCardimg.adeb7bba.PNG";